/**
 * Better Auth client (admin-facing).
 *
 * Same-origin: the auth handler runs at /api/auth/* on the same Vercel deployment
 * as the frontend, so cookies set by Better Auth flow naturally to subsequent
 * fetches without CORS gymnastics.
 */

import { createAuthClient } from "better-auth/react";

const baseURL =
  import.meta.env.VITE_BETTER_AUTH_URL ?? window.location.origin;

export const authClient = createAuthClient({
  baseURL,
});

export const { signIn, signUp, signOut, useSession } = authClient;
